// extracted by mini-css-extract-plugin
export default {"img":"SQaNSPRlgei5Y4LSZ6Tj"};